export default __webpack_public_path__ + "static/media/famille.d083a304.png";